import styled from 'styled-components';
import { Group, Radio, Box, palette, radius, spacing } from '@landr/maestro';

export const LineThrough = styled.span<{ hasLineThrough: boolean }>`
    ${({ hasLineThrough }) =>
        hasLineThrough &&
        `
text-decoration: line-through;
`};
`;

export const Bold = styled.span`
    font-weight: 700;
`;

export const UspWrapper = styled(Box)`
    text-align: left;
`;

export const PriceWrapper = styled(Box)``;

export const PlanWrapper = styled(Box)`
    border-radius: ${radius('base')};
    cursor: pointer;
    width: 100%;
`;

export const MostPopularWrapper = styled(Box)`
    text-align: center;
    text-transform: uppercase;
    background-color: ${palette('primary.500', 0.32)};
    color: ${palette('primary.700')};
    font-weight: 700;
    border-top-left-radius: ${radius('base')};
    border-top-right-radius: ${radius('base')};
    line-height: 1;
`;

export const InnerWrapper = styled(Box)<{ isChecked: boolean }>`
    padding: ${spacing('lg')};
    border: 1px solid ${palette('neutral.200')};
    border-bottom-left-radius: ${radius('base')};
    border-bottom-right-radius: ${radius('base')};
    background-color: ${palette('neutral.100')};

    ${({ isChecked }) =>
        !isChecked &&
        `
        background-color: transparent;
    `};
`;

export const HeaderGroup = styled(Group)`
    vertical-align: middle;
    width: 100%;
`;

export const LeftColumn = styled(Group.Item)`
    flex-grow: 0;
    /* maestro-no-token */
    width: 16px;
    align-self: center;
`;

export const RightColumn = styled(Group.Item)`
    flex-grow: 1;
    text-align: left;
`;

export const PlanNameItem = styled(Group.Item)`
    flex-grow: 1;
    text-align: left;
    align-self: center;
`;

export const PlanCost = styled(Group.Item)`
    flex-grow: 0;
`;

export const ContentGroup = styled(Group)`
    vertical-align: middle;
    width: 100%;
`;

export const RadioNoPadding = styled(Radio)`
    padding: 0;
`;
